import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
} from "@/components/ui/empty";
import { NotificationItem } from "../notification-item";
import { profileAction } from "@/redux/actions/profileAction";
import { Notification } from "../../types";

const Pipeline = () => {
  const dispatch = useDispatch<any>();
  const allNotifications = useSelector(
    (s: any) => s.profile?.notifications_n || []
  );
  const loading = useSelector((s: any) => s.profile?.loading || false);

  useEffect(() => {
    dispatch(profileAction.getNotifications({ limit: 20, offset: 0 }));
  }, [dispatch]);

  // Filter notifications for pipeline-related types
  const notifications = allNotifications.filter(
    (notification: Notification) =>
      notification.notification_type === "pipeline_created"
  );

  const updateNotificationStatus = (params: {
    notification?: any;
    redirect?: boolean;
    otherSwitch?: boolean;
  }) => {
    const { notification, redirect = false } = params;
    if (notification) {
      dispatch(
        profileAction.updateNotification({
          id: notification.id,
          type: notification.notification_type || "message",
          data: notification,
          redirect,
        })
      );
    }
  };

  if (loading && notifications.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-sm text-muted-foreground">
          Loading notifications...
        </div>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <Empty>
          <EmptyContent>
            <EmptyHeader>No pipeline notifications</EmptyHeader>
            <EmptyDescription>
              You don't have any pipeline notifications yet
            </EmptyDescription>
          </EmptyContent>
        </Empty>
      </div>
    );
  }

  return (
    <div className="max-h-[400px] overflow-y-auto p-2 space-y-2">
      {notifications.map((notification: Notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          tabValue={2}
          updateNotificationStatus={updateNotificationStatus}
          readStatus={notification.read_status === 1}
        />
      ))}
    </div>
  );
};

export { Pipeline };
